module.exports = __webpack_public_path__ + "img/125.8af14e81.jpg";